import { render, staticRenderFns } from "./SendLetterReviewStep.vue?vue&type=template&id=ad54674a&"
import script from "./SendLetterReviewStep.vue?vue&type=script&lang=js&"
export * from "./SendLetterReviewStep.vue?vue&type=script&lang=js&"
import style0 from "./SendLetterReviewStep.vue?vue&type=style&index=0&id=ad54674a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports